import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_ACT_SHIPPING, ADD_ACT_SHIPPING, UPDATE_ACT_SHIPPING, DELETE_ACT_SHIPPING } from './actionTypes';
import {
  getActShippingsSuccess,
  getActShippingsFail,
  addActShippingSuccess,
  addActShippingFail,
  updateActShippingSuccess,
  updateActShippingFail,
  deleteActShippingSuccess,
  deleteActShippingFail,
  showLoading,
  hideLoading
} from './actions';
import { getActShippingsInfo, addActShipping, updateActShipping, deleteActShipping } from '../../helpers/backend_helper';
import { showToast } from '../../components/Toast';

function* fetchActShippingInfo() {
  try {
    yield put(showLoading(true));
    const response = yield call(getActShippingsInfo);
    yield put(getActShippingsSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getActShippingsFail(error));
  }
}
function* onAddActShipping({ payload: act_shipping }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addActShipping, act_shipping);
    showToast('New Actividan Order is added');
    yield put(addActShippingSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addActShippingFail(error.response));
  }
}
function* onUpdateActShipping({ payload: act_shipping }) {
  try {
    yield put(showLoading(true));
    const response = yield call(updateActShipping, act_shipping);
    showToast('Changes Successfully Applied');
    yield put(updateActShippingSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(updateActShippingFail(error));
  }
}
function* onDeleteActShipping({ payload: act_shipping }) {
  try {
    yield put(showLoading(true));
    const response = yield call(deleteActShipping, act_shipping);
    showToast('Order is deleted from the system');
    yield put(deleteActShippingSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(hideLoading(false));
    yield put(deleteActShippingFail(error));
  }
}
function* lostOrdersSaga() {
  yield takeEvery(GET_ACT_SHIPPING, fetchActShippingInfo);
  yield takeEvery(ADD_ACT_SHIPPING, onAddActShipping);
  yield takeEvery(UPDATE_ACT_SHIPPING, onUpdateActShipping);
  yield takeEvery(DELETE_ACT_SHIPPING, onDeleteActShipping);
}

export default lostOrdersSaga;